import { IMemberList } from "app/containers/Features/components/MemberSelection/types";
import { IPagination, sortOrder } from "app/types";


export interface ISelectedMembers {
  email: string;
  teamMemberId: string;
}

export enum ProjectMemberStatus {
  ACTIVE = "active",
  INVITATION_PENDING = "invitation pending",
  INVITATION_REJECTED = "invitation rejected",
  INVITATION_EXPIRED = "invitation expired",
}

export interface ProjectMemberListSettingState {
  loading: boolean;
  buttonLoading: boolean;
  list: IMemberList[];
  orderBy: string;
  orderDir: sortOrder;
  pagination: IPagination;
  selectedMembers: ISelectedMembers[];
}
